var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightArrowWithBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6469 10.1402L12.0004 14.7866L7.35398 10.1402C7.20753 9.99372 7.20753 9.75628 7.35398 9.60984C7.50042 9.46339 7.73786 9.46339 7.88431 9.60984L11.6469 13.3724L12.0004 13.726L12.354 13.3724L16.1165 9.60983C16.263 9.46339 16.5004 9.46339 16.6469 9.60984C16.7933 9.75628 16.7933 9.99372 16.6469 10.1402Z",
    fill: "#8082C5",
    stroke: "#8082C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightArrowWithBorder);
export default __webpack_public_path__ + "static/media/lightArrowWithBorder.16575c49d5a8545228cf0c3192b02d35.svg";
export { ForwardRef as ReactComponent };